import '../styles/main.styl';

import { initSwiper } from './components/swiper';
import { initHeader } from './components/header';
import { initSearchOverlay } from './components/search';
import { initAside } from './components/aside';
import { initSticky } from './components/sticky';
import { initNavScroll } from './components/navScroll';
import { initA11y } from './components/a11y';
import { initVideo } from './components/video';
import { initLightbox } from './components/lightbox';
import { initShare } from './components/share';
import { initNewsFilter } from './components/newsFilter';
import { initBg } from './components/bg';
import { initTabYears } from './components/tabYears';
import { initModal } from './components/modal';
import { initCarrerasFilter } from './components/carrerasFilter';
import { initFaq } from './components/faq';
import { initFolders } from './components/folders';

document.addEventListener("DOMContentLoaded", function() {

  // Body load
  const bodyElement = document.getElementById("body");
  if (bodyElement) bodyElement.classList.add("body--loaded");

  // Header
  initHeader();

  // Search
  initSearchOverlay();

  // Aside
  initAside();

  // Sticky
  initSticky();

  // NavScroll
  initNavScroll();

  // Accesibility
  initA11y();

  // Videos
  initVideo();

  // Lightbox
  initLightbox();

  // Share
  initShare();

  // News filter
  initNewsFilter();

  // Tab years
  initTabYears();

  // Modal
  initModal();

  // Carreras live filter
  initCarrerasFilter();

  // FAQ (acordeón + filtro)
  initFaq();

  // Folders (archivos colapsables)
  initFolders();

  // BG
  initBg();

  // SWIPER
  initSwiper();
  
    
});

